module.exports = __webpack_public_path__ + "img/tips-packing-icon.ce0040da.svg";